import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to top on route change (unless there's a hash anchor)
 * This component MUST be rendered inside a BrowserRouter
 */
export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top if there's no hash (hash scrolling is handled by HashScrollHandler)
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location.pathname, location.hash]);

  return null;
}

/**
 * Handles hash-based scrolling on route changes and browser back/forward navigation
 * This component MUST be rendered inside a BrowserRouter
 */
export function HashScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Small delay to ensure DOM is ready after navigation
      const timeoutId = setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [location.hash, location.key]);

  return null;
}
